import { Schema } from 'effect';

import type { CurrencyT } from '../../../../config/currency';

import type { OrderItem } from '../../../bind/order';
import { GtmAddShippingInfoEventSchema } from '@vs-shop/schemas/gtm/add-shipping-info';
import type { OrderDetail } from '../../../schema/openapi/backend';
import type { OrderShipmentStorageT } from '../../../service/orderShipment/OrderShipment';
import { storedPlacementId } from '@vs-shop/engine/service/orderShipment/OrderShipment';

export const createAddShippingInfoPayloadFromOrder = (
  orderData: OrderDetail,
  cartItems: OrderItem[],
  shipmentData: OrderShipmentStorageT,
  currency: CurrencyT
) => {
  const shippingPrice = shipmentData.shipment.shippingPriceWithoutVat / 100;

  return Schema.decodeEffect(GtmAddShippingInfoEventSchema)({
    event: 'track.add_shipping_info',
    ecommerce: {
      currency,
      value: (orderData.frontAllItemsPriceWithoutVatAfterDiscount ?? 0) / 100,
      shipping_tier: shipmentData.shipment.shippingName,
      shipping_placement_id: storedPlacementId(shipmentData) ?? undefined,
      shipping_method_code: shipmentData.shipment.shippingMethodCode,
      shipping_method_price: shippingPrice,
      items: cartItems.map((item) => ({
        id: item.variant.code,
        name: item.productName ?? '',
        price: (item.variant.priceWithoutTax ?? 0) / 100,
        price_with_tax: (item.frontUnitPriceWithVat ?? 0) / 100,
        quantity: item.quantity,
      })),
    },
  });
};
